/** localStorage 操作 hook */
import { useCallback, useState } from 'react';

const jsonParse = <T>(value: string | null, defaultValue: T) => {
  try {
    return JSON.parse(value || '') as T;
  } catch {
    return defaultValue;
  }
};

const useStorage = <T>(key: string, defaultValue: T) => {
  const [value, setValue] = useState<T>(jsonParse<T>(localStorage.getItem(key), defaultValue));

  const write = useCallback(
    (newValue: T) => {
      setValue(newValue);
      localStorage.setItem(key, JSON.stringify(newValue));
    },
    [setValue],
  );

  return [value, write] as const;
};

export const useStorageArr = <T>(key: string, defaultValue: T[] = []) => {
  const [value, setValue] = useStorage(key, defaultValue);

  const append = useCallback(
    (newValue: T) => {
      setValue(value.concat(newValue));
    },
    [setValue],
  );

  return [value, append] as const;
};

export default useStorage;
